import { render, staticRenderFns } from "./NewChannel.vue?vue&type=template&id=044ec534&scoped=true"
import script from "./NewChannel.vue?vue&type=script&lang=js"
export * from "./NewChannel.vue?vue&type=script&lang=js"
import style0 from "./NewChannel.vue?vue&type=style&index=0&id=044ec534&prod&lang=scss&scoped=true"
import style1 from "./NewChannel.vue?vue&type=style&index=1&id=044ec534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044ec534",
  null
  
)

export default component.exports